import { SwiperSlide } from "swiper/react"
import HTMLReactParser from "html-react-parser"
import { Breadcrumb } from "@components/anti/Breadcrumb"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import { linkProductsServicesCinema } from "src/helper/page-url"
import { useScrollAnim } from "src/hooks/hooks"
import LottieWrapper from "@components/global/LottieWrapper"
import animationData from "@public/lottie/lottie_main-banner.json"
import CardCinema from "@components/global/CardCinema"
import { convertHtmlToReact } from "src/mixins"
import { translations } from "src/helper/translations"

function ProductsServicesCover({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-products-services-cover" ref={trigger}>
      {/* <LottieWrapper
        animationData={animationData}
        className="lottie-products-services-cover"
      /> */}
      <div className="container">
        <Breadcrumb
          path={`/${translations[`product_services_${locale}`]}`}
          theme="dark"
        />
      </div>
      <div className="py-main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-title">
              <h1 className={`title ${anim(1)}`}>
                {data && data[`title_${locale}`]}
              </h1>
              <div className={`text ${anim(2)}`}>
                {convertHtmlToReact(data[`description_${locale}`])}
              </div>
            </div>
            <div className="col-lg-8">
              <SliderSwiper
                breakpoints={{
                  640: {
                    slidesPerView: 1.6,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                }}
                className="product-services-cover"
              >
                {data?.cinema?.map((item, i) => (
                  <SwiperSlide key={`product-services-cover__item-${i}`}>
                    <CardCinema
                      slug={item.slug}
                      className={`product-services-cover__item ${
                        item.slug
                      } ${anim(i + 3)}`}
                      link={`${linkProductsServicesCinema}/${item.slug}`}
                      {...item}
                    />
                  </SwiperSlide>
                ))}
              </SliderSwiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsServicesCover
